// Компонент флаера

import {
  Box,
  Button,
  CardMedia,
  Typography,
  useMediaQuery,
} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

export const FlyerCard = ({ translations }) => {
  const isMobile = useMediaQuery("(max-width: 900px");
  return (
    <Box
      sx={{
        // width: "200%",
        height: "600px",
        display: "flex",
        flexDirection: !isMobile ? "row" : "column",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
        borderRadius: "8px",
        marginBottom: "50px",
        marginTop: "100px",
        position: "relative",
      }}>
      {/* Левая часть с изображением */}
      <CardMedia
        component="img"
        image="/XXL_height.webp" // Укажите путь к вашему изображению
        alt="Flyer"
        sx={{
          position: isMobile ? "absolute" : "relative", // Позиционируем изображение относительно контейнера
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: isMobile ? 0 : 2, // На мобильной версии изображение будет на заднем плане
          width: isMobile ? "100%" : "48%",
          height: "100%",
          objectFit: "cover",
          borderTopRightRadius: isMobile ? "0" : "120px", // Радиус для десктопа
          borderBottomRightRadius: isMobile ? "0" : "120px", // Радиус для десктопа
        }}
      />

      {/* Псевдо-элемент для затемнения на мобильной версии */}
      {isMobile && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Затемнение
            zIndex: 1, // Это затемнение будет поверх изображения, но под контентом
          }}
        />
      )}

      {/* Правая часть с текстом */}
      <Box
        sx={{
          width: "52%",
          height: "100%",
          padding: "40px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          backgroundColor: !isMobile ? "#f4f4f4" : "transparent",
          zIndex: isMobile ? 3 : 1,
        }}>
        <Typography
          variant="h3"
          component="div"
          fontWeight="bold"
          color={isMobile ? "white" : "black"}
          gutterBottom>
          {translations["flyer_card_1"]}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            marginBottom: "20px",
            fontSize: "1.2rem",
          }}
          color={isMobile ? "white" : "black"}>
          {translations["flyer_card_2"]}
        </Typography>
        <Button
          variant="contained"
          sx={{
            mt: 2,
            backgroundColor: "#1976d2",
            color: "#fff",
            "&:hover": { backgroundColor: "#1565c0" },
          }}>
          {translations["flyer_card_btn"]}
        </Button>
      </Box>
    </Box>
  );
};
